// extracted by mini-css-extract-plugin
module.exports = {"ThankYou":"styles_ThankYou__3Sc6H","fadeIn":"styles_fadeIn__2LF4x","ThankYou-title":"styles_ThankYou-title__3WZXJ"};